import ReactModal from 'react-modal'

import {
  wrapper,
  closeButtonWrap,
  closeButton,
} from './style'
import { Title03 } from 'components/Typography/Title03'
import { SettingModalTypes } from "types"
import { Color } from 'utils/variables'

export const SettingModal = ({isOpen, onRequestClose, label, children}: SettingModalTypes) => {
  return (
    <ReactModal
        isOpen={isOpen}
        onRequestClose={() => onRequestClose()}
        ariaHideApp={false}
        contentLabel={label}
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(14, 14, 14, 0.6)',
            zIndex: 10001,
          },
          content: {
            height: 'auto',
            position: 'absolute',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            transform: 'translate3d(-50%, -50%, 0)',
            border: 'none',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            outline: 'none',
            borderRadius: '0',
            background: 'none',
            padding: '0',
            fontFamily: 'Hiragino Kaku Gothic Pro'
          }
        }}
      >
        <div className={wrapper}>
          {children}
        </div>
        <div className={closeButtonWrap} onClick={() => onRequestClose()}>
          <div className={closeButton}>
            <Title03 color={Color.White}>閉じる</Title03>
          </div>
        </div>
      </ReactModal>
  );
}